import React from 'react'
import gql from 'graphql-tag'
import find from 'lodash.find'
import {
  Query
} from 'react-apollo'

import apolloClient from '../../../services/ApolloClient'
import ResearchThemeButtonGroup from './ResearchThemeButtonGroup'

const STATE = gql`
  query ResearchThemeButtonGroupContainer {
    research @client {
      selectedTheme {
        id
        name
      }
    }
  }
`

export default class ResearchThemeButtonGroupContainer extends React.PureComponent {
  generateHandleButtonChange = (themes) => {
    return (selectedThemeName) => {
      var selectedTheme = {};

      selectedTheme = find(themes, { name: selectedThemeName })

      if (!selectedTheme) {
        selectedTheme = {
          __typename: 'Theme',
          id: 0,
          name: ''
        }
      }

      apolloClient.writeData({
        data: {
          research: {
            __typename: 'ResearchState',
            selectedTheme,
            selectedCategories: [0],
            selectedProducts: [0],
            selectedMeasurementUnit: null,
            selectedPeriod: {
              __typename: 'ResearchSelectedPeriodState',
              start: 1990,
              end: 2010
            },
            selectedTerritories: [],
            selectedTerritoryType: 'regions',
            collapses: {
              __typename: 'ResearchCollapsesState',
              isCollapse2Collapsed: false,
              isCollapse3Collapsed: false,
              isCollapse4Collapsed: false,
            }
          }
        }
      })
    }
  }

  renderComponent = ({ data }) => (
    <ResearchThemeButtonGroup
      onChange={this.generateHandleButtonChange(this.props.themes)}
      selectedTheme={data.research.selectedTheme}
    />
  )

  render() {
    return (
      <Query query={STATE}>
        {this.renderComponent}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchThemeButtonGroup/ResearchThemeButtonGroup.container.js